import React from "react";
import { SingleSignOnPendingComponent } from "./SingleSignOnPendingComponent";
import {
  ThirdPartyLoopError,
  thirdPartyLoopMessageMap,
} from "../StepThirdPartyLoop/StepThirdPartyLoopComponent";
import { ThirdPartyLoopProvider, VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { getQueryOrOption } from "../../lib/ServerApi/TestingRouteOverrides";
import { ThirdPartyLoopResponse } from "../../lib/types/types";
import { QUERY_STRING_THIRD_PARTY_PROVIDER_OVERRIDE } from "../../constants";
import { ButtonType } from "../SingleSignOnComponent";

interface ThirdPartyLoopPendingProps {
  logo: React.ReactNode;
  cancelThirdPartyLoop: () => void;
  verificationLastResponse: ThirdPartyLoopResponse;
  isMockingPreviousStepThirdPartyLoop: boolean;
}

const ThirdPartyLoopPending = ({
  logo,
  verificationLastResponse,
  cancelThirdPartyLoop,
  isMockingPreviousStepThirdPartyLoop,
}: ThirdPartyLoopPendingProps) => {
  const thirdPartyLoopProvider = isMockingPreviousStepThirdPartyLoop
    ? (getQueryOrOption(QUERY_STRING_THIRD_PARTY_PROVIDER_OVERRIDE) as ThirdPartyLoopProvider)
    : verificationLastResponse?.thirdPartyLoopProvider;

  const thirdPartyLoopMessages = thirdPartyLoopMessageMap[thirdPartyLoopProvider] || undefined;

  if (!thirdPartyLoopMessages) {
    return <ThirdPartyLoopError logo={logo} />;
  }

  return (
    <SingleSignOnPendingComponent
      stepName={VerificationStepsEnum.thirdPartyLoop}
      messages={thirdPartyLoopMessages}
      logo={logo}
      cancelSingleSignOn={cancelThirdPartyLoop}
      cancelButtonType={ButtonType.SECONDARY}
    />
  );
};

export const ThirdPartyLoopPendingComponent = ThirdPartyLoopPending;
